import React, { Fragment, useEffect, useState } from 'react';

import { withStyles } from '@mui/material/styles';

import { Layout, MenuItemLink, Responsive} from 'react-admin';

import SettingsIcon from '@mui/icons-material/Settings';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import LabelIcon from '@mui/icons-material/Label';
import { Box, Typography } from "@mui/material";

import BookmarksIcon from '@mui/icons-material/Bookmarks';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookIcon from '@mui/icons-material/Book';
import CloudIcon from '@mui/icons-material/Cloud';
import HttpIcon from '@mui/icons-material/Http';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import HomeIcon from '@mui/icons-material/Home';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';
import DvrIcon from '@mui/icons-material/Dvr';

import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { Link, useNavigate } from 'react-router-dom';
import InsightsIcon from '@mui/icons-material/Insights';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
const menuItems = [
    { name: '', text: 'Home', icon: <HomeIcon />, type: 'menu', link:'/' },
    { name: '', text: 'IDE(beta)', icon: <DeveloperBoardIcon />, type: 'menu', link:'/ide' },
    {
        name: 'management', text: 'Management', icon: <InsightsIcon />, type: 'category',
        children: [{ name: 'project', text: 'Project', icon: <DvrIcon />, link:'project'},]
    },

    { 
        name: 'app', text: 'App', icon: <DvrIcon />, type: 'category' ,
        children:[
            { name: 'sketch', text: 'Sketch', icon: <AccountTreeIcon /> , link:'sketch'},
            { name: 'screen', text: 'Screen', icon: <BookmarkIcon /> , link:'screen'},
            { name: 'block', text: 'Block', icon: <BookIcon /> , link:'block'},
        ]
    },
    
    { name: 'admin', text: 'Backend', icon: <DvrIcon />, type: 'category' ,
    children:[
        { name: 'resource', text: 'Entity', icon: <ChromeReaderModeIcon /> , link:'resource'},
    ]
    
    },
    
    { name: 'market', text: 'Market', icon: <StorefrontIcon />, type: 'category' ,
        children:[
            { name: 'library', text: 'Use Library', icon: <DraftsIcon /> , link:'library'},
            { name: 'draft', text: 'My Library', icon: <StarBorder /> , link:'draft'},
        ]
    },
];

const styles = {
    menu: {
    },
};

const MyMenu = ({ }) => {
    const navigate = useNavigate();
    const [projectId, setProjectId] = useState(null);
    useEffect(() => {
        setProjectId(localStorage.getItem('devil_project'))
    }, [localStorage.getItem('devil_project')])

    const [open, setOpen] = useState(true);

    const handleClick = (e, item) => {
        if(item.link)
            navigate(item.link)
        else 
            setOpen(!open)
    };

    return (
        <div>
            <List
                sx={{
                    // width: '100%',
                    // maxWidth: 360, 
                    // bgcolor: 'background.paper' 
                }}
                component="nav"
            >
                {menuItems.map((item, index) => (
                    <Box key={index}>
                        <ListItemButton onClick={e=>handleClick(e, item)}>
                            <ListItemIcon>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItemButton>

                        {item.children &&
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {item.children && item.children.map((c, index) => (
                                    <ListItemButton key={index} sx={{ pl: 4 }} component={Link} to={c.link || '/'}>
                                        <ListItemIcon>
                                            {c.icon}
                                        </ListItemIcon>
                                        <ListItemText primary={c.text} />
                                    </ListItemButton>
                                ))}
                            </List>
                            </Collapse>
                        }
                    </Box>
                ))}

            </List>
            
        </div>
    )
};

export default MyMenu;


